import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Slot-driven React template for the catch-all Static Content page whose
 * backend {@code metadata.templateUid} is {@code "StaticContentPageTemplate"}
 * (legacy {@code layout/staticContentPage.jsp}).
 *
 * Structure-copy parity of {@code staticContentPage.jsp}: a two-column flex
 * layout ({@code #st4content}) with the in-page navigation (20%, sticky) on the
 * left and the main content (80%) on the right. The {@code #st4content} id is
 * the typography hook styled by {@code st4Content.less}; the column flex
 * proportions come from the JSP inline styles (not LESS), so they are reproduced
 * here. {@code .scha__sticky-navigation} ({@code misc.less}) makes the nav column
 * sticky.
 *
 * Catch-all static-content pages ({@code /static/legalnotice},
 * {@code /static/dataprivacy}) have no React island, so {@code body} is null and
 * ALL rendered content comes from the two page-scoped CMS slots:
 * {@code NavigationInPageSlot} and {@code ST4ContentSlot}.
 */
export function StaticContentPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <div className="d-flex" id="st4content">
      <div style={{ flex: "0 0 20%", marginRight: "16px" }}>
        <div className="scha__sticky-navigation">{slots.renderSlot("NavigationInPageSlot")}</div>
      </div>
      <div style={{ flex: "1 1 0%", marginLeft: "16px" }}>{slots.renderSlot("ST4ContentSlot")}</div>
      {body}
    </div>
  );
}
